import React from 'react';
import UnlockableSection from './unlockable_section';

type Props = {
  insightsPropertyId: string;
  showOnClick?: boolean;
}

export default function Owners({ insightsPropertyId, showOnClick }: Props) {
  return (
    <UnlockableSection
      insightsPropertyId={insightsPropertyId}
      showOnClick={showOnClick || false}
    />
  );
}
